import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ToastModule } from 'primeng/toast';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { LoginService } from '@/app/services/login.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, NavbarComponent, FooterComponent, ToastModule, SpinnerComponent],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'hal-priv';
  currentUrl: string = '';
  private readonly sessionCheckIntervalMs = 60000;

  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  checkSessionExpiration() {
    this.loginService.logoutIfLoginTimeExpired();
  }

  ngOnInit() {
    this.checkSessionExpiration();
    setInterval(() => this.checkSessionExpiration(), this.sessionCheckIntervalMs);

    this.currentUrl = this.router.url;

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects;
    });
  }

  hideNavbar(): boolean {
    if (!this.currentUrl) {
      return false;
    }

    const hiddenRoutes = [
      '/mis-adhesiones/detalles/editar-rpts',
      '/catalogo-ia/proyectos/nuevo-proyecto',
      '/catalogo-ia/sistemas-de-ia/nuevo-sistema',
      '/nueva-adhesion',
      '/catalogo-ia/uso-de-solucion-ia/nuevo-uso-de-solucion-ia',
    ];
    if (hiddenRoutes.some((route) => this.currentUrl.includes(route))) {
      return true;
    }

    if (this.currentUrl.includes('/catalogo-ia/proyectos/detalles/') && this.currentUrl.endsWith('/revision')) {
      return true;
    }

    if (this.currentUrl.includes('/catalogo-ia/sistemas-de-ia/') && this.currentUrl.endsWith('/desplegar-sistema')) {
      return true;
    }

    return false;
  }
}
